import { useLocale } from '@/contexts/LocaleContext';
import { useCallback } from 'react';

/**
 * Hook for formatting prices in the user's selected currency
 * Prices are stored in EUR internally, and converted to the user's currency
 */
export const usePrice = () => {
  const { formatPrice, convertPrice, currency, currencySymbol, isConverting } = useLocale();

  /**
   * Format a price in EUR to the user's selected currency
   */
  const format = useCallback((priceEur: number): string => {
    return formatPrice(priceEur);
  }, [formatPrice]);

  /**
   * Format a price range in EUR to the user's selected currency
   */
  const formatRange = useCallback((minPriceEur: number, maxPriceEur: number): string => {
    return `${formatPrice(minPriceEur)} - ${formatPrice(maxPriceEur)}`;
  }, [formatPrice]);

  /**
   * Convert a price in EUR to the user's selected currency (async for real-time rates)
   */
  const convert = useCallback(async (priceEur: number): Promise<number> => {
    return convertPrice(priceEur);
  }, [convertPrice]);

  return {
    format,
    formatRange,
    convert,
    currency,
    currencySymbol,
    isConverting
  };
};
